import React from "react";
import IconDownloadBox from "@/components/icons/IconDownloadBox";
import IconRocket from "@/components/icons/IconRocket";
import Button from "@/components/forms/Button/Button";
import DateRangePickerSelect from "@/components/forms/DateRangePicker/DateRangePickerSelect";
import Flex from "../Flex/Flex";
import { setLocalStorageItem } from "@/utils/localStorageUtils";

const DateRangeButtons = ({
    timeFrame,
    setTimeFrame,
    localStorageKey='analyticsTimeFrame'
}) => {
    return (
        <Flex gap={2} align="center">
            <div>
                <DateRangePickerSelect defaultValue={timeFrame} onSelectDateRange={(dateRange) => {
                    setTimeFrame({ from: dateRange.from, to: dateRange.to, label: dateRange.label });
                    if (localStorageKey) {
                        setLocalStorageItem(localStorageKey, dateRange)
                    }
                }} />
            </div>
            {/* <Button type="secondary">
                <Flex gap={2} align="center">
                    <IconDownloadBox width={16} height={16}/>
                    Export
                </Flex>
            </Button>
            <Button type="secondary">
                <Flex gap={2} align="center">
                    <IconRocket size={16}/>
                    Share
                </Flex>
            </Button> */}
        </Flex>
    )
}

export default DateRangeButtons;